import type { ReactElement } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const LINK_ROW_COUNT = 4;

export function LinkColumnPdSkeleton(): ReactElement {
    return (
        <div aria-hidden="true" className="flex w-full flex-col gap-3 px-4 py-2" data-testid="link-column-pd-skeleton">
            <Skeleton className="h-5 w-40" />
            {Array.from({ length: LINK_ROW_COUNT }, (_, index) => (
                <Skeleton key={`link-${index}`} className="h-8 w-48" />
            ))}
        </div>
    );
}

export default LinkColumnPdSkeleton;
